import React from "react";
import { useAuth } from "./AuthContext";
import { Redirect } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const { isLoggedIn, isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>; // Optional: Spinner or placeholder
  }

  if (!isLoggedIn) {
    return <Redirect to="/auth/login-page" />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
